import { JetView } from 'webix-jet';
import { devConfig, countries, gamesCasino } from '../../../config/config';

/**
 * Class representing the tableMessagesView.
 * @extends JetView
 */
export default class tableMessagesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            rows: [
                {
                    id: 'preloader',
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            scrollY: true,
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'),
                                    /**
                                     * Template for detail icon.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {String} HTML string for the detail icon.
                                     */
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ClientFromId',
                                    header: _('Emisor'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'ClientToId',
                                    header: _('Receptor'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateCreation',
                                    header: _('Fecha Creación'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha Expiración'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Title',
                                    header: _('Asunto'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Read',
                                    header: _('Leido'),
                                    editor: 'combo',
                                    options: [
                                        { id: '1', value: _('Si') },
                                        { id: '0', value: _('No') },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'),
                                    editor: 'combo',
                                    options: [
                                        { id: '0', value: _('Mensaje') },
                                        { id: '1', value: _('Pop Up') },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'UserNetwork',
                                    header: _('Tipo de red'),
                                    editor: 'combo',
                                    options: [
                                        { id: '0', value: _('Punto de venta') },
                                        { id: '1', value: _('Concesionario') },
                                        {
                                            id: '2',
                                            value: _('Subconcesionario'),
                                        },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                            ],
                            /**
                             * Event handler for clicking the detail icon.
                             * @param {Event} euv - The event object.
                             * @param {String} id - The ID of the clicked row.
                             */
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id);
                                    console.log(item.Message);
                                    webix
                                        .ui({
                                            view: 'window',
                                            move: true,
                                            width: 500,
                                            height: 500,
                                            fullscreen: screen.width < 500 ? true : false,
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('Mensaje'),
                                                        align: 'center',
                                                    },
                                                    {
                                                        view: 'icon',
                                                        icon: 'wxi-close',
                                                        click: function () {
                                                            this.getTopParentView().hide();
                                                        },
                                                    },
                                                ],
                                            },
                                            modal: true,
                                            position: 'center',
                                            body: {
                                                view: 'scrollview',
                                                scroll: 'xy',
                                                body: {
                                                    cols: [
                                                        {
                                                            /**
                                                             * Template for displaying the message.
                                                             * @param {Object} obj - The data object for the message.
                                                             * @returns {String} HTML string for the message.
                                                             */
                                                            template: function (obj) {
                                                                return (
                                                                    "<div class='my-messages'>" +
                                                                    item.Message +
                                                                    '</div>'
                                                                );
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        })
                                        .show();
                                },
                            },
                            math: true,
                            loadahead: 0,
                            datafetch: devConfig.getDefaultDataFetch(),
                            pager: 'pagerA',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable');
        var url = devConfig.geturlApi() + 'BetShop/GetMessagesSent';
        var filter = '';
        var popupAdd = webix.ui({
            view: 'window',
            id: 'AddMessages',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Mensaje') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'form',
                id: 'addform',
                elements: [
                    {
                        rows: [
                            {
                                view: 'text',
                                label: _('ID Usuario'),
                                labelWidth: 200,
                                name: 'ClientId',
                            },
                            {
                                view: 'datepicker',
                                label: _('Fecha Expiración'),
                                labelWidth: 200,
                                name: 'DateExpiration',
                                timepicker: true,
                            },
                            {
                                view: 'text',
                                label: _('Asunto'),
                                labelWidth: 200,
                                name: 'Title',
                            },
                            {
                                view: 'richselect',
                                name: 'CountrySelect',
                                id: 'CountrySelect',
                                labelWidth: 200,
                                label: "<span class='icon-language'></span>" + _('País'),
                                placeholder: _('Click para seleccionar '),
                                options: {
                                    body: {
                                        /**
                                         * Template for displaying country options.
                                         * @param {Object} obj - The data object for the country.
                                         * @returns {String} HTML string for the country option.
                                         */
                                        template: function (obj) {
                                            return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                        },
                                        data: countries,
                                    },
                                },
                            },
                            {
                                view: 'combo',
                                labelWidth: 200,
                                label: _('Tipo'),
                                name: 'Type',
                                options: [
                                    { id: '0', value: _('Mensaje') },
                                    { id: '1', value: _('Pop Up') },
                                ],
                            },
                            {
                                view: 'combo',
                                labelWidth: 200,
                                label: _('Tipo de red'),
                                name: 'UserNetwork',
                                options: [
                                    { id: '0', value: _('Punto de venta') },
                                    { id: '1', value: _('Concesionario') },
                                    { id: '2', value: _('Subconcesionario') },
                                ],
                            },
                            {
                                view: 'ckeditor5',
                                label: _('Mensaje'),
                                name: 'Message',
                                /**
                                 * Event handler for CKEditor ready event.
                                 * @param {Object} eventData - The event data.
                                 */
                                onReady(eventData) {
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        return new UploadAdapter(loader);
                                    };
                                },
                                ready: function (eventData) {
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        return new UploadAdapter(loader);
                                    };
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide();
                                    $$('addform').setValues($$('addform').getCleanValues());
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('addform').getValues();
                                    const json = JSON.stringify(values, (key, val) => {
                                        if (typeof val === 'string') {
                                            return val
                                                .replace(/ñ/g, '&#241;')
                                                .replace(/Ñ/g, '&#209;')
                                                .replace(/á/g, '&#225;')
                                                .replace(/Á/g, '&#193;')
                                                .replace(/é/g, '&#233;')
                                                .replace(/É/g, '&#201;')
                                                .replace(/í/g, '&#237;')
                                                .replace(/Í/g, '&#205;')
                                                .replace(/ó/g, '&#243;')
                                                .replace(/Ó/g, '&#211;')
                                                .replace(/ú/g, '&#250;')
                                                .replace(/Ú/g, '&#218;');
                                        }
                                        return val;
                                    });
                                    var objJsonB64 = btoa(unescape(encodeURIComponent(json)));
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(devConfig.geturlApi() + 'BetShop/SendMessage', objJsonB64, {
                                            error: function (text, data, XmlHttpRequest) {
                                                webix.message(_('Error! '));
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                webix.message('Mensaje enviado');
                                                grid.clearAll();
                                                grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                            },
                                        });
                                    $$('addform').setValues($$('addform').getCleanValues());
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        /**
         * Event listener for filtering messages.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'messages:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
        });
        /**
         * Event listener for showing the add message popup.
         * @param {Object} filter - The filter criteria (not used).
         */
        this.on(this.app, 'addMessage:button', (filter) => {
            popupAdd.show();
        });
    }
}

// FILE DOCUMENTED
